import { render } from "./RecordLink.vue?vue&type=template&id=5026270f"
import script from "./RecordLink.vue?vue&type=script&lang=js"
export * from "./RecordLink.vue?vue&type=script&lang=js"

import exportComponent from "/home/Daten/Entwicklung/repositories/bdl_ui/de.stone.bdl.management.ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__